import {useQuery} from '@tanstack/react-query'
import React, {useState, useEffect} from 'react'
import Layout from '../../components/Layout/Layout'
import axios from 'axios'
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { FaTrashAlt,FaCut,FaPlusCircle,FaPencilAlt,FaCheck,FaTimes,FaWallet,FaEdit,FaTrash } from "react-icons/fa";
import {Button, Modal, Form,Table,Pagination } from 'react-bootstrap';
import { AutoComplete } from 'rsuite';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { SERVER_API } from '../../fileWithConstants';
import { Spinner } from 'react-bootstrap';
import { useAuth } from '../../context/auth';
const FabricListing = () => {
  const [auth, setAuth] = useAuth();
  const [userRole, setUserRole] = useState(auth.user.user_role);
  const [userId, setUserId] = useState(auth.user.id);
  const [userRolelist, setuserRolelist] = useState(auth.user.userrole);
  const [fabrics, setFabrics] = useState([]);
  const [categoryName, setCategoryName] = useState({});
  const [supplierName, setSupplierName] = useState([]);
  const [show, setShow] = useState(false);
  const [showAddFabric, setShowAddFabric] = useState(false);
  const [addQty, setAddQty] = useState("");
  const [addPrice, setAddPrice] = useState("");

  const [inwardshow, setInwardshow] = useState(false);
  const [outwardshow, setOutwardshow] = useState(false);
  
  const [inwardQty, setInwardQty]=useState([]);
  const [outardQty, setOutwardQty]=useState([]);
  const [avlFabric, setAvlFabric]=useState([]);
  const [avlQty, setAvlQty]=useState('');

  const [orderNo, setOrderNo] = useState('');
  const [cutQty, setCutQty] = useState('');
  const [validated, setValidated] = useState(false);

  const [selectedFabricName, setSelectedFabricName] = useState('');
  const [selectedParentId, setSelectedParentId] = useState('');
  const [fabricnames, setFabricnames] = useState([]);

  const [categories, setCategories] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(0);
  const [checkStatus, setCheckStatus] = useState();

  const [selectedThaan, setSelectedThaan] = useState(0);
  const [selectedThaanPrice, setSelectedThaanPrice] = useState(0);
  const [selectedThanId, setSelectedThanId] = useState(null);





const Loader = () => (
  <div className="text-center my-4">
    <Spinner animation="border" role="status" variant="primary">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  </div>
);

const getFabricData = async(checkStatus=2)=>{
  try {
    setLoading(true);
    const {data} = await axios.get(`${SERVER_API}/api/v1/fabric/get-fabricdata/${selectedCategory}/${page}/1`);
    //console.log(data)
    if(data?.success && data?.fabrics.length>0){
      const fb_main_arr = data?.fabrics;
      setFabrics(fb_main_arr);
      const fab_names = fb_main_arr.map((fab)=>fab.name)
      setFabricnames(fab_names);
      setLoading(false);
    }else{
      setLoading(false);
      //toast.error('Some thing went wrong while getting fabric data.')
    }
  } catch (error) {
    console.log(error)
  }
}

  const handleClose = () => {
    setShow(false);
    setAvlQty('');
    setInwardshow(false);
    setOutwardshow(false)
    setShowAddFabric(false);
  } 

  const getAllSupplier = async()=>{
    try {
      const {data} = await axios.get(`${SERVER_API}/api/v1/supplier/get-all-supplier`);
      if(data?.success && data?.suppliers?.length>0){
        const all_sup = data?.suppliers;
        const supp_key_val={};
        all_sup?.forEach((s)=>{
          supp_key_val[s.v_id]=s.code;
        })
        setSupplierName(supp_key_val);
      }
    } catch (error) {
      console.log(error)
    }
  }
  
  const getAllFabricCategory = async()=>{
    try {
      const {data} = await axios.get(`${SERVER_API}/api/v1/fabric/get-fabric-category`);
      if(data?.success){
        const all_cat = data?.category;
        setCategories(all_cat);
        const cat_key_val={};
        all_cat?.forEach((c)=>{
          cat_key_val[c.id]=c.name;
        })
        setCategoryName(cat_key_val);
      }
    } catch (error) {
      console.log(error)
    }
  }

useEffect(()=>{
   getAllSupplier();
   getAllFabricCategory();
  getFabricData();
},[]);

const deleteFabric = async(fid)=>{
try {
 const answer = window.confirm('Are you sure, you want to delete this?');
  if(!answer) return;
  const {data} = await axios.delete(`${SERVER_API}/api/v1/fabric/delete-fabric/${fid}`);
  if(data?.success){
    toast.success('Fabric delete successfully.')
    getFabricData();
  }
} catch (error) {
  console.log(error)
}
 
}

const handleFabricCut = async(e)=>{
  const form = e.currentTarget;
  e.preventDefault();
 
  if (form.checkValidity() === false) {
    e.stopPropagation();
    setValidated(true);
    return false;
  }

  try {
    const {data} = await axios.post(`${SERVER_API}/api/v1/fabric/cut-fabric/`,{orderNo,cutQty,selectedFabricName,selectedParentId,selectedThaan,selectedThaanPrice,selectedThanId});
    
    if(data?.success){
      toast.success(data?.message)
      setShow(false);
      getFabricData();
      /* navigate('/fabric-list') */
    }else{
      toast.error(data?.message)
    }
    setSelectedParentId("");
    setOrderNo("");
    setCutQty("");
  } catch (error) {
    console.log(error)
  }
}



const showFormPopup = async(fbname, parent_id)=>{
  setShow(true);
  setAvlQty('');
  setSelectedFabricName(fbname);
  setSelectedParentId(parent_id);
  setValidated(false);
  setOrderNo('');
  setCutQty("");
  try {
    setAvlQty('');
     const {data} = await axios.get(`${SERVER_API}/api/v1/fabric/get-avl-fabric-qty/${parent_id}`);
     if(data?.success){
        //setAvlQty(data.fabric[0]?.avl_qty);
        setAvlFabric(data.fabric);
     }
   } catch (error) {
    setAvlQty('');
     console.log(error)
   }

}

const showInwardPopup = async(fbname, parent_id)=>{
  setInwardshow(true);
  setSelectedFabricName(fbname);
  setSelectedParentId(parent_id);
  try {
    setInwardQty([]);
     const {data} = await axios.get(`${SERVER_API}/api/v1/fabric/get-fabric-inward-qty/${parent_id}`);
     if(data?.success){
      setInwardQty(data.fabric);
     }
   } catch (error) {
    setInwardQty([]);
     console.log(error)
   }
}

const showOutwardPopup = async(fbname, parent_id)=>{
  setOutwardshow(true);
  setSelectedFabricName(fbname);
  setSelectedParentId(parent_id);
  try {
     const {data} = await axios.get(`${SERVER_API}/api/v1/fabric/get-fabric-outward-qty/${parent_id}`);
     if(data?.success){
      setOutwardQty(data.fabric);
     }
   } catch (error) {
    setOutwardQty([]);
     console.log(error)
   }
}

const searchFabric = async(fbname)=>{
  try {
    if(fbname!=='' && fbname.length>4){
      setFabrics([]);
      setLoading(true);
      //setSelectedCategory(0)
      const {data} = await axios.get(`${SERVER_API}/api/v1/fabric/get-fabric-search/${fbname}`);
      if(data?.success){

        //console.log(data); return false;
         setFabrics(data?.fabrics);
         setLoading(false);
      }
      setLoading(false);
    }else if(fbname===''){
      setFabrics([]);
      setLoading(true);
      setTimeout(() => {
        getFabricData();
        setLoading(false);
      }, 5000);
      
    }
   } catch (error) {
    setOutwardQty([]);
     console.log(error)
   }
}

const handleCategoryChange = async(selectedOptions)=>{
    try {
      //console.log('==>>>',selectedOptions); return false;
      
      if(selectedOptions.length>0){
          const st_cat  = selectedOptions?.[0]['id'];
          setFabrics([]);
          setLoading(true);
          setSelectedCategory(st_cat);
            const {data} = await axios.get(`${SERVER_API}/api/v1/fabric/get-fabricdata/${st_cat}/${page}/1`);
            //console.log(data)
            if(data?.success && data?.fabrics.length>0){
              const fb_main_arr = data?.fabrics;
              setFabrics(fb_main_arr);
              const fab_names = fb_main_arr.map((fab)=>fab.name)
              setFabricnames(fab_names);
              setLoading(false);
            }else{
              setFabrics([]);
              setLoading(false);
            }
        
      }
    } catch (error) {
      setLoading(false);
      console.log(error)
    }
}

const handleChangeCheck = (e)=>{
  setCheckStatus(e.target.value);
  setLoading(false);
  setFabrics([]);
  getFabricData(e.target.value);
}

const thanChange = (than_no) => {
  const selectedItem = avlFabric.find((item) => item.than_no === than_no);
  if (selectedItem) {
    setAvlQty(selectedItem.avl_qty); // ✅ update available qty state dynamically
    setSelectedThaanPrice(selectedItem.price); // ✅ update available qty state dynamically
  } else {
    setAvlQty('');
  }
};

const handleDelete = async (id) => {
  if (!window.confirm("Are you sure you want to delete this record?")) {
    return;
  }

  try {
    // auth.user
    /* await axios.delete(`${SERVER_API}/api/v1/fabric/fabric-outward-delete/${id}`); */

    await axios.delete(`${SERVER_API}/api/v1/fabric/fabric-outward-delete/${id}`, {
      data: { userId },
    });

    // Remove deleted row from state
    setOutwardQty((prev) => prev.filter((item) => item.id !== id));

    toast.success("Record deleted successfully.");
  } catch (error) {
    console.error(error);
    toast.error("Failed to delete record.");
  }
};

const totalValue = fabrics?.reduce((total, fb) => {
  const value = Number(fb.balance || 0) * Number(fb.price || 0);
  return total + (isNaN(value) ? 0 : value);
}, 0);

  return (
    <Layout title={'Fabric Listing'}>
        <div className='container'>
            <h1 className='page-title'>Fabric List</h1>
            <div className="row justify-content-center"><div className="col-md-12 custom-inline-form"><div className="form-box big-box">
            <AutoComplete
            name='name'
            placeholder="Search for fabric..."
            defaultValue=""
            onChange={(value,e)=>{ searchFabric(value); }}
            />
            </div>
            <div className='form-box big-box'>
                      <Typeahead
                            name="supplier_id"
                            id="basic-typeahead-single"
                            labelKey="name"
                            onChange={handleCategoryChange}
                            options={categories}
                            placeholder="Select Category"
                        />
            </div>
            <div className='form-box btn-box'> <Link className="btn btn-primary" to="/dashboard/fabric-list" onClick={()=>{ window.location.reload(); }}>Reset</Link></div>
           
            <div className='form-box btn-box'> <Link to={'/dashboard/add-fabric'} className='btn btn-primary float-end'>+ Add Fabric</Link></div>

            </div></div>
            
            <div className='col-md-12 m-t5'>
  <div className='table-box'>
    {loading ? (
      <Loader />
    ) : (
      <table className="table table-responsive table-hover table-sticky">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col" className='text-start'>Name</th>
            <th scope="col" className='text-start'>Supplier Fabric Name</th>
            <th scope="col">Photo</th>
            <th scope="col">Category</th>
            <th scope="col">Status</th>
            <th scope="col">Supplier</th>
            <th scope="col">Total QTY</th>
            <th scope="col">AVL QTY</th>
            <th scope="col">Price</th>
            <th scope="col">Value [{totalValue.toLocaleString('en-US')}]</th>
            <th scope="col" width="100">Action</th>
          </tr>
        </thead>
        <tbody>
          {fabrics && fabrics.length > 0 ? (
            fabrics.map((fb, index) => (
              <tr key={fb.id} className={fb.primary_fabric === 1 ? 'table-warning' : ''}>
                <td>{index + 1}</td>
                <td className='text-start'>{fb.name}</td>
                <td>{fb.supplierfbname}</td>
                <td>
                  {fb.fabric_photo !== '' ? (
                    <Link to={`${SERVER_API}/uploads/fabrics/${fb.fabric_photo}`} target='_blank'>
                      <img
                        src={`${SERVER_API}/uploads/fabrics/${fb.fabric_photo}`}
                        alt={fb.name}
                        width="50"
                      />
                    </Link>
                  ) : ("")}
                </td>
                <td>{categoryName[fb.category]}</td>
                <td>{fb.check_status === 1 ? <FaCheck className='text-success' /> : ''}</td>
                <td>{supplierName[fb.supplier]}</td>
                <td>
                  <Link to='#' onClick={() => { showInwardPopup(fb.name, fb.id) }} className='text-dark text-bold'>
                    {(fb.total_in)?.toLocaleString("en-US")}
                  </Link>
                </td>
                <td>
                  <Link to='#' onClick={() => { showOutwardPopup(fb.name, fb.id) }} className='text-dark text-bold'>
                    {(fb.total_in - fb.total_out)?.toLocaleString("en-US")}
                  </Link>
                </td>
                <td>{fb.price || ''}</td>
                <td>
                  {isNaN(fb.balance * fb.price) ? '' : (fb.balance * fb.price).toLocaleString('en-US')}
                </td>
                <td className='action-td'>
                  <Link to='#' onClick={() => { showFormPopup(fb.name, fb.id) }} className='text-danger' title='Cut Fabric'><FaCut /></Link>
                  <Link to={`/dashboard/update-fabric/${fb.id}`} className='text-primary' title="Edit Fabric"><FaPencilAlt /></Link>
                  <div className='action-box' style={{ display: "none" }}>
                    <Link to='#' onClick={() => deleteFabric(fb.id)} className='text-danger'><FaTrashAlt /></Link>
                  </div>
                  <Link to={`/dashboard/add-fabric-opening-balance/${fb.id}`} className='text-primary' title="Opening Balance"><FaWallet /></Link>

                
                  {(userRole === '1' || userRolelist?.includes('material_edit')) && (
                    <Link
                      to={`/dashboard/edit-fabric-opening-balance/${fb.id}`}
                      className="text-warning"
                      title="Edit Opening Balance"
                    >
                      <FaEdit />
                    </Link>
                  )}
                  </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="12" className="text-center text-muted">No fabrics found.</td>
            </tr>
          )}
        </tbody>
      </table>
    )}
  </div>
</div>
</div>
        
        <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Fabric Cut: {selectedFabricName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated} onSubmit={handleFabricCut}>
          <input type="hidden" name="parent_id" aria-label="Default select example" value={selectedParentId} />
            <Form.Group className="mb-3">
              <Form.Label>Order No.:</Form.Label>
              <Form.Control
                type="text"
                name="order_no"
                placeholder="Order No"
                onChange={(e)=>setOrderNo(e.target.value)}
                value={orderNo}
                controlId="validationCustom04"
                required
              />
              <Form.Control.Feedback type="invalid">
              Please provide a valid Order No.
            </Form.Control.Feedback>
            </Form.Group>
            

          <Form.Group className="mb-3">
          <Form.Label>Select Thaan:</Form.Label>
          <Form.Select
            name="than_no"
            value={selectedThaan}
            onChange={(e) => {
              const selectedOption = e.target.selectedOptions[0];
              const thanId = selectedOption.getAttribute("data-id");
              setSelectedThanId(thanId);
              const value = e.target.value;
              setSelectedThaan(value);  // update state
              thanChange(value);        // trigger alert or any logic
            }}
            required
          >
            <option value="">-- Select Thaan No --</option>
            {avlFabric.map((avfb) => (
              <option key={avfb.id} value={avfb.than_no} data-id={avfb.id}> 
                {avfb.than_no}
              </option>
            ))}
          </Form.Select>
          <Form.Control.Feedback type="invalid">
            Please select a Thaan No.
          </Form.Control.Feedback>
        </Form.Group>


            <Form.Group className="mb-3">
              <Form.Label>Fabric QTY:</Form.Label>
              {avlQty !== '' && (
                <p className="text-success">Available Qty: {avlQty}</p>
              )}
              <Form.Control
                type="number"
                name="outward_qty"
                placeholder="Fabric QTY"
                onChange={(e) => setCutQty(e.target.value)}
                value={cutQty}
                required
                min="0.01"
                max={avlQty}
                step="any"
              />
              <Form.Control.Feedback type="invalid">
                Please provide a valid Fabric QTY.
              </Form.Control.Feedback>
            </Form.Group>


          <Button className='btn btn-success' type="submit">Cut Fabric</Button>

          </Form>
        </Modal.Body>
      </Modal>

      <Modal show={inwardshow} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Inward Detail: {selectedFabricName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Warehouse</th>
                    <th>Thaan No.</th>
                    <th>QTY</th>
                    <th>Price</th>
                    <th>Date of Entry</th>
                  </tr>
                </thead>
                <tbody>
                    {inwardQty?.map((fb,index)=>(
                      <tr key={index}>
                      <td>{index+1}</td>
                      <td>{fb.fb_name}</td>
                      <td>{fb.than_status===1?'Intransit':fb.warehouse_name}</td>
                      <td>{fb.than_no}</td>
                      <td>{fb.qty}</td>
                      <td>{fb.price}</td>
                      <td>{fb.created_at}</td>
                    </tr>
                    ))}
                </tbody>
              </Table>
        </Modal.Body>
      </Modal>

      <Modal show={outwardshow} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Outward Detail: {selectedFabricName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Order No.</th>
                    <th>Thaan No.</th>
                    <th>QTY</th>
                    <th>Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                    {outardQty?.map((fb,index)=>(
                      <tr key={index}>
                      <td>{index+1}</td>
                      <td>{fb.name}</td>
                      <td>{fb.order_no}</td>
                      <td>{fb.than_no}</td>
                      <td>{fb.outward_qty}</td>
                      <td>{fb.outward_at}</td>
                       
                      <td className="text-center">
                        {fb.created_at?.substring(0, 10) >= "2026-01-01" && (
                          <button
                            type="button"
                            className="btn btn-outline-danger btn-sm"
                            onClick={() => handleDelete(fb.id)}
                            title="Delete"
                          >
                            <FaTrash />
                          </button>
                        )}
                      </td>

                    </tr>
                    ))}
                </tbody>
              </Table>
        </Modal.Body>
      </Modal>
      
    </Layout>
  )
}

export default FabricListing